// Module registration lives here; the shared filter engine has no module dependencies.
import { mandateFormSchema, contractFormSchema } from './documents/components/creation/documentCreation.schemas';
import useModuleFilters from '../shared/data/useModuleFilters';
import { formSchema as client } from './clients/config/clientForm.schema';
import { formSchema as supplier } from './suppliers/config/supplierForm.schema';
import { formSchema as staff } from './staff/config/staffForm.schema';
import { formSchema as user } from './workspace-users/config/workspaceUserForm.schema';
import { assignmentFormSchema } from './deals/config/assignmentForm.schema';
import { proposalFormSchema, activeDealFormSchema, completedDealFormSchema } from './deals/config/dealForm.schema';
import { expenseFormSchema, invoiceFormSchema, paymentFormSchema } from './accounting/config/accountingForm.schemas';
import { documentFormSchema } from './documents/components/library/documentForm.schema';
import { calendarFormSchema } from './calendar/config/calendarForm.schema';
import { listClientCustomFields } from './clients/services/client-custom-fields.service';
import { listSupplierCustomFields } from './suppliers/services/suppliers.service';
import { listStaffCustomFields } from './staff/services/staff.service';
import { listDealsCustomFields } from './deals/services/deals-custom-fields.service';
import { listAccountingCustomFields } from './accounting/services/accounting-custom-fields.service';
import { listDocumentsCustomFields } from './documents/services/documents-custom-fields.service';
import { listCalendarCustomFields } from './calendar/services/calendar-custom-fields.service';

export const moduleFilterSchemas = {
  clients: { schema: client, listCustomFields: listClientCustomFields },
  suppliers: { schema: supplier, listCustomFields: listSupplierCustomFields },
  staff: { schema: staff, listCustomFields: listStaffCustomFields },
  proposals: { schema: proposalFormSchema, listCustomFields: listDealsCustomFields },
  activeDeals: { schema: activeDealFormSchema, listCustomFields: listDealsCustomFields },
  completedDeals: { schema: completedDealFormSchema, listCustomFields: listDealsCustomFields },
  tasks: { schema: assignmentFormSchema, listCustomFields: listDealsCustomFields },
  expenses: { schema: expenseFormSchema, listCustomFields: listAccountingCustomFields },
  invoices: { schema: invoiceFormSchema, listCustomFields: listAccountingCustomFields },
  payments: { schema: paymentFormSchema },
  documents: { schema: [documentFormSchema, mandateFormSchema, contractFormSchema], customFormKeys: ['documents.mandate.create', 'documents.contract.create'], listCustomFields: listDocumentsCustomFields },
  calendar: { schema: calendarFormSchema, listCustomFields: listCalendarCustomFields },
  users: { schema: user },
};
export default function useRegisteredModuleFilters(moduleId, rows, relations) {
  const definition = moduleFilterSchemas[moduleId];
  if (!definition) throw new Error(`Schema filtri mancante: ${moduleId}`);
  return useModuleFilters({ ...definition, rows, relations, scope: moduleId });
}
